import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const netWorth: AnswerPathTreeNode = { path: 'netWorth', nodeId: NodeIds.insuredNetWorth };
